import axiosClient from "./axiosClient";

const getHealthReport = async () => {
  return await axiosClient.get(`reports/commentary`);
};

export { getHealthReport };
